import { render, staticRenderFns } from "./ItemImageAssociationCardIndex.vue?vue&type=template&id=70d68f88&"
import script from "./ItemImageAssociationCardIndex.vue?vue&type=script&lang=js&"
export * from "./ItemImageAssociationCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports